import { render, staticRenderFns } from "./customerarchives.vue?vue&type=template&id=1148a0aa&scoped=true&"
import script from "./customerarchives.vue?vue&type=script&lang=js&"
export * from "./customerarchives.vue?vue&type=script&lang=js&"
import style0 from "./customerarchives.vue?vue&type=style&index=0&id=1148a0aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1148a0aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1148a0aa')) {
      api.createRecord('1148a0aa', component.options)
    } else {
      api.reload('1148a0aa', component.options)
    }
    module.hot.accept("./customerarchives.vue?vue&type=template&id=1148a0aa&scoped=true&", function () {
      api.rerender('1148a0aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/customerarchives/customerarchives.vue"
export default component.exports